import $ from 'jquery'

export function GalleriesOverview() {
  let PWS;
  PWS = typeof (PWS) === 'undefined' ? {} : PWS;
  PWS.isTabletScreenSize = document.documentElement.clientWidth + window.scrollbarWidth < 1280 && document.documentElement.clientWidth >= 768;
  PWS.isMobileScreenSize = document.documentElement.clientWidth < 768;
  PWS.smallHeightScreenSize = document.documentElement.clientHeight < 756;
  PWS.windowScrollTop = 0;

  let resizeTimer;

  if (window.intervalIds) {
    window.intervalIds.forEach(clearInterval);
  }
  window.intervalIds = [];

  if (window.timeoutIds) {
    window.timeoutIds.forEach(clearTimeout);
  }
  window.timeoutIds = [];

  let pageAnimationTimeout,
    heroAnimationTimeout,
    heroSliderTimeout,
    sliderInterval,
    gradientCurrentTimeout,
    desktopCurrentTimeout,
    mobileGeneralTimeout,
    mobileCurrentTimeout;

  pageAnimationTimeout = setTimeout(function () {
    pageAnimationTimeout = null;

    // Periods removing on desktop
    $('.galleries__hero__footer__text').each(function () {
      var
        $e = $(this),
        html = $(this).html();

      $e.html(html.replace(/\./g, '<span class="galleries__hero__footer__text__period">.</span>'));
    });

    // Hero animation
    heroAnimationTimeout = setTimeout(function () {
      heroAnimationTimeout = null;

      // Hero Slider
      $('.galleries__slider__desktop__item:first').addClass('-show');
      heroSliderTimeout = setTimeout(function () {
        heroSliderTimeout = null;
        $('.galleries__slider__mobile__item:first').addClass('-show');
      }, 200);
      window.timeoutIds.push(heroSliderTimeout);
      $('.galleries__subhero__gradient:first').addClass('-show');

      var
        $desktop_next,
        $mobile_next,
        $gradient_next,
        $desktop_current,
        $mobile_current,
        $gradient_current;

      sliderInterval = setInterval(function () {
        $desktop_current = $('.galleries__slider__desktop__item.-show');
        $mobile_current = $('.galleries__slider__mobile__item.-show');
        $gradient_current = $('.galleries__subhero__gradient.-show');

        $desktop_next =
          ($desktop_current.next('.galleries__slider__desktop__item').length > 0)
            ? $desktop_current.next('.galleries__slider__desktop__item')
            : $('.galleries__slider__desktop__item:first');

        $mobile_next =
          ($mobile_current.next('.galleries__slider__mobile__item').length > 0)
            ? $mobile_current.next('.galleries__slider__mobile__item')
            : $('.galleries__slider__mobile__item:first');

        $gradient_next =
          ($gradient_current.next('.galleries__subhero__gradient').length > 0)
            ? $gradient_current.next('.galleries__subhero__gradient')
            : $('.galleries__subhero__gradient:first');

        $gradient_next.addClass('-show');
        $gradient_current.addClass('-hide');
        gradientCurrentTimeout = setTimeout(function () {
          gradientCurrentTimeout = null;
          $gradient_current.removeClass('-show');
          $gradient_current.removeClass('-hide');
        }, 400);
        window.timeoutIds.push(gradientCurrentTimeout);

        $desktop_next.addClass('-show');
        $desktop_current.addClass('-hide');
        desktopCurrentTimeout = setTimeout(function () {
          desktopCurrentTimeout = null;
          $desktop_current.removeClass('-show');
          $desktop_current.removeClass('-hide');
        }, 400);
        window.timeoutIds.push(desktopCurrentTimeout);

        mobileGeneralTimeout = setTimeout(function () {
          mobileGeneralTimeout = null;
          $mobile_next.addClass('-show');
          $mobile_current.addClass('-hide');
          mobileCurrentTimeout = setTimeout(function () {
            mobileCurrentTimeout = null;
            $mobile_current.removeClass('-show');
            $mobile_current.removeClass('-hide');
          }, 400);
          window.timeoutIds.push(mobileCurrentTimeout);
        }, 100);
        window.timeoutIds.push(mobileGeneralTimeout);
      }, 3500);
      window.intervalIds.push(sliderInterval);
    }, 600);
    window.timeoutIds.push(heroAnimationTimeout);
  }, 500);
  window.timeoutIds.push(pageAnimationTimeout);

  // Undo animations when going to the external link
  $('a[href^="http"]').not('[target="_blank"]').on('click.pxtrigger', function () {
    $('.galleries__slider__desktop__item, .galleries__slider__mobile__item, .galleries__subhero__gradient').removeClass('-show').removeClass('-hide');
  });

  // Features section animations
  function scrollableSections() {
    if (
      $('.galleries__features__scrollable').length > 0 &&
      !PWS.isTabletScreenSize &&
      !PWS.isMobileScreenSize
    ) {
      let $header = $('.galleries__features__header');
      let $container = $('.galleries__features__scrollable');
      let $wrapper = $('.galleries__features__scrollable-wrapper');
      let scrollTop = $(window).scrollTop();
      let viewportHeight = $(window).height();
      let $itemsPseudo = $('.galleries__features__scrollable-wrapper__pseudo-item');
      let $itemP1 = $itemsPseudo.eq(0);
      let $itemP2 = $itemsPseudo.eq(1);
      let $itemP3 = $itemsPseudo.eq(2);
      let $itemP4 = $itemsPseudo.eq(3);
      let $items = $('.galleries__features__scrollable__item');
      let $item1 = $items.eq(0);
      let $item2 = $items.eq(1);
      let $item3 = $items.eq(2);

      let $galleryWindow = $('.galleries__features__scrollable__pseudo-window');
      let $galleryImage = $('.galleries__features__scrollable__pseudo-window__gallery');
      let $fullWindowImage = $('.galleries__features__scrollable__pseudo-window__image');

      let scrollDepth = $galleryWindow.height() - $galleryImage.height();
      let scrollProgress = 0;
      let startPos = 0;
      let endPos = 0;
      let totalDistance = 0;
      let currentDistance = 0;
      let newTop = 0;

      let scrollPosition = PWS.windowScrollTop;
      let currentScroll = scrollTop;

      let scrollDirection = (currentScroll > scrollPosition) ? 'down' : 'up';

      // Fix and unfix container if it is in viewport or not (top side)
      if (scrollTop >= $wrapper.offset().top) {
        $container.addClass('-fixed');
      } else {
        $container.removeClass('-fixed');
      }

      // Unfix if it is above of viewport
      if (scrollTop >= $wrapper.offset().top + $wrapper.height() - viewportHeight) {
        $container.removeClass('-fixed').addClass('-above-viewport');
      } else {
        $container.removeClass('-above-viewport');
      }

      // Animation of the each item

      // Scroll above elements
      if (scrollTop < $itemP1.offset().top) {
        $item1.removeClass('-show').removeClass('-up').addClass('-down'); // Hide 1
        $item2.removeClass('-show'); // Hide 2
        $item3.removeClass('-show'); // Hide 3
      }

      // #1 in viewport
      if (
        scrollTop >= $header.offset().top &&
        scrollTop < $itemP2.offset().top
      ) {
        $item1.addClass('-show'); // Show 1
        $item2.removeClass('-show'); // Hide 2
        $item3.removeClass('-show'); // Hide 3

        // Item 2
        $item2.removeClass('-up').addClass('-down');

        // Show illustrations for Item 1
        if (scrollTop >= $itemP1.offset().top + $(window).height()) $item1.addClass('-show-illustration');
        else $item1.removeClass('-show-illustration');
      }

      // #2 in viewport
      if (
        scrollTop >= $itemP2.offset().top &&
        scrollTop < $itemP3.offset().top
      ) {
        $item1.removeClass('-show'); // Hide 1
        $item2.addClass('-show'); // Show 2
        $item3.removeClass('-show'); // Hide 3

        // Item 1
        if (scrollDirection === 'down') $item1.removeClass('-down').addClass('-up');

        // Item 3
        if (scrollDirection === 'down') $item3.removeClass('-up').addClass('-down');

        // Show illustrations for Item 2
        if (scrollTop >= $itemP2.offset().top + $(window).height()) $item2.addClass('-show-illustration');
        else $item2.removeClass('-show-illustration');
      }

      // #3 in viewport
      if (
        scrollTop >= $itemP3.offset().top &&
        scrollTop < $itemP4.offset().top
      ) {
        $item1.removeClass('-show'); // Hide 1
        $item2.removeClass('-show'); // Hide 2
        $item3.addClass('-show'); // Show 3

        // Item 2
        if (scrollDirection === 'down') $item2.removeClass('-down').addClass('-up');

        // Show illustrations for Item 3
        if (scrollTop >= $itemP3.offset().top + $(window).height()) $item3.addClass('-show-illustration');
        else $item3.removeClass('-show-illustration');
      }

      // Pseudo Window show/hide
      if (scrollTop >= $header.offset().top - $(window).height() / 3) $galleryWindow.addClass('-show');
      else $galleryWindow.removeClass('-show');

      // Gallery scroll
      if (
        scrollTop >= $wrapper.offset().top + viewportHeight / 4 &&
        scrollTop < $itemP3.offset().top
      ) {
        startPos = $wrapper.offset().top + viewportHeight / 4;
        endPos = $itemP3.offset().top;
        totalDistance = endPos - startPos;
        currentDistance = scrollTop - startPos;

        scrollProgress = (currentDistance / totalDistance) * 100;
        newTop = (scrollProgress / 100) * scrollDepth;

        $galleryImage.css({
          top: newTop + 'px'
        });
      }

      // Full Window Image show/hide
      if (scrollTop >= $itemP3.offset().top + viewportHeight / 4) $fullWindowImage.addClass('-show');
      else $fullWindowImage.removeClass('-show');
    }
  }

  // Cover section animations
  function coverAnimations() {
    if (
      $('.galleries__cover').length > 0 &&
      !PWS.isTabletScreenSize &&
      !PWS.isMobileScreenSize
    ) {
      let $wrapper = $('.galleries__cover__wrapper');
      let $pseudo = $('.galleries__cover__pseudo');
      let $big = $('.galleries__cover__big');
      let bigWidth = ($(window).height() + 300) * 1.78;
      let bigHeight = $(window).height() + 300;
      let bigTop = -20;
      let bigLeft = (($(window).height() + 300) * 1.78 - $(window).width()) / -2;
      let $content = $('.galleries__cover__big__content');
      let $small = $('.galleries__cover__small');
      let scrollTop = $(window).scrollTop();
      let viewportHeight = $(window).height();

      let targetWidth = 441;
      let targetHeight = 242;
      let targetTop = $small.position().top + 68;
      let targetLeft = $small.position().left + 259;
      let scrollProgress = 0;
      let startPos = 0;
      let endPos = 0;
      let totalDistance = 0;
      let currentDistance = 0;
      let width = ($(window).height() + 300) * 1.78;
      let height = $(window).height() + 300;
      let top = 0;
      let left = (($(window).height() + 300) * 1.78 - $(window).width()) / -2;

      let fontSize = $(window).height() * 0.12;
      let initFontSize = $(window).height() * 0.12;
      let targetFontSize = 20;

      // Fix and unfix container if it is in viewport or not (top side)
      if (scrollTop >= $pseudo.offset().top) {
        $wrapper.addClass('-fixed');
      } else {
        $wrapper.removeClass('-fixed');
      }

      // Unfix if it is above of viewport
      if (scrollTop >= $pseudo.offset().top + $pseudo.height() - viewportHeight) {
        $wrapper.removeClass('-fixed').addClass('-above-viewport');
      } else {
        $wrapper.removeClass('-above-viewport');
      }

      // Big image transform
      if (
        scrollTop >= $pseudo.offset().top &&
        scrollTop < $pseudo.offset().top + $pseudo.height() / 2
      ) {
        startPos = $pseudo.offset().top;
        endPos = $pseudo.offset().top + $pseudo.height() / 2;
        totalDistance = endPos - startPos;
        currentDistance = scrollTop - startPos;

        scrollProgress = (currentDistance / totalDistance) * 100;
        width = bigWidth + (scrollProgress / 100) * (targetWidth - bigWidth);
        height = bigHeight + (scrollProgress / 100) * (targetHeight - bigHeight);
        top = bigTop + (scrollProgress / 100) * (targetTop - bigTop);
        left = bigLeft + (scrollProgress / 100) * (targetLeft - bigLeft);

        $big.css({
          width: Math.round(width) + 'px',
          height: Math.round(height) + 'px',
          top: Math.round(top) + 'px',
          left: Math.round(left) + 'px'
        });

        fontSize = initFontSize + (scrollProgress / 100) * (targetFontSize - initFontSize);

        $content.css({
          'font-size': fontSize + 'px'
        });
      }

      // Small image transform
      if (scrollTop >= $pseudo.offset().top + $pseudo.height() / 2) {
        $small.addClass('-show');
      } else {
        $small.removeClass('-show');
      }
    }
  }

  // Integration section animations
  function scrollableIntegrationSections() {
    if (
      $('.galleries__integration__scrollable').length > 0 &&
      !PWS.isTabletScreenSize &&
      !PWS.isMobileScreenSize
    ) {
      let $header = $('.galleries__integration__header');
      let $container = $('.galleries__integration__scrollable');
      let $wrapper = $('.galleries__integration__scrollable-wrapper');
      let scrollTop = $(window).scrollTop();
      let viewportHeight = $(window).height();
      let $itemsPseudo = $('.galleries__integration__scrollable-wrapper__pseudo-item');
      let $itemP2 = $itemsPseudo.eq(1);
      let $itemP3 = $itemsPseudo.eq(2);
      let $items = $('.galleries__integration__scrollable__item');
      let $item1 = $items.eq(0);
      let $item2 = $items.eq(1);

      let scrollPosition = PWS.windowScrollTop;
      let currentScroll = scrollTop;

      let scrollDirection = (currentScroll > scrollPosition) ? 'down' : 'up';

      // Fix and unfix container if it is in viewport or not (top side)
      if (scrollTop >= $wrapper.offset().top) {
        $container.addClass('-fixed');
      } else {
        $container.removeClass('-fixed');
      }

      // Unfix if it is above of viewport
      if (scrollTop >= $wrapper.offset().top + $wrapper.height() - viewportHeight) {
        $container.removeClass('-fixed').addClass('-above-viewport');
      } else {
        $container.removeClass('-above-viewport');
      }

      // Animation of the each item

      // Scroll above elements
      if (scrollTop < $header.offset().top - $(window).height() / 2) {
        $item1.removeClass('-show').removeClass('-up').addClass('-down'); // Hide 1
        $item2.removeClass('-show'); // Hide 2
      }

      // #1 in viewport
      if (
        scrollTop >= $header.offset().top - $(window).height() / 2 &&
        scrollTop < $itemP2.offset().top
      ) {
        $item1.addClass('-show'); // Show 1
        $item2.removeClass('-show'); // Hide 2

        // Show illustrations for Item 1
        $item1.addClass('-show-illustration');

        // Item 2
        if (scrollDirection === 'down') $item2.removeClass('-up').addClass('-down');
      }

      // #2 in viewport
      if (
        scrollTop >= $itemP2.offset().top &&
        scrollTop < $itemP3.offset().top
      ) {
        $item1.removeClass('-show'); // Hide 1
        $item2.addClass('-show'); // Show 2

        // Item 1
        if (scrollDirection === 'down') $item1.removeClass('-down').addClass('-up');

        // Show illustrations for Item 2
        $item2.addClass('-show-illustration');

        // Show mobile illustration for Item 2
        if (scrollTop >= $itemP2.offset().top + $(window).height() * 1.3) $item2.addClass('-show-mobile');
        else $item2.removeClass('-show-mobile');
      }
    }
  }

  // When scrolling
  $(window).on('scroll.pxtrigger', function () {
    scrollableSections();
    coverAnimations();
    scrollableIntegrationSections();
    PWS.windowScrollTop = $(this).scrollTop();
  });

  // When resize stopped
  $(window).on('resize.pxtrigger', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      scrollableSections();
      coverAnimations();
      scrollableIntegrationSections();
      PWS.windowScrollTop = $(this).scrollTop();
    }, 250);
  });
}
